module.exports = __webpack_public_path__ + "docs/dns-provisioning-2.1.1.pdf";